export default "__VITE_ASSET__3d3a101d__"